<template>
  <img v-if="photo" :src="photo" @error="onError" />
  <Placeholder v-else :id="id || name" :name="name" />
</template>

<script setup>
import Placeholder from "./Placeholder.vue";

defineProps({ photo: String, name: String, id: String });

function onError(evt) {
  evt.currentTarget.src =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23ccc' d='M6 17h12l-3.75-5l-3 4L9 13zm-3 4V3h18v18zm5.5-11q.625 0 1.063-.437T10 8.5t-.437-1.062T8.5 7t-1.062.438T7 8.5t.438 1.063T8.5 10'/%3E%3C/svg%3E";
}
</script>
